module.exports = __webpack_public_path__ + "img/handcraft_md.4033fea.webp";